module.exports = __webpack_public_path__ + "images/RebrandedVivaEngageHeroBanner-758eb6bf54f4aa7a33627a32aec8e574.png";